<mat-form-field>
  <mat-select [(ngModel)]="type" placeholder="Typ">
    <mat-option value="default">Frei</mat-option>
    <mat-option value="ibex2">ibex2</mat-option>
  </mat-select>
</mat-form-field>

<ng-container *ngIf="type === 'ibex2'">
  <mat-form-field><input [(ngModel)]="ibex2Token" matInput placeholder="ibex2 Token"></mat-form-field>
</ng-container>

<ng-container *ngIf="type === 'default'">
  <div class="fields">
    <smart-input [(model)]="token" key="title"></smart-input>
    <smart-input [(model)]="token" key="logo"></smart-input>
    <smart-input [(model)]="token" key="endpoint"></smart-input>
    <smart-input [(model)]="token" key="type"></smart-input>
    <smart-input [(model)]="token" key="target"></smart-input>
  </div>
  <mat-card appearance="outlined">
    <mat-card-title>Parameter</mat-card-title>
    <div *ngFor="let parameter of token.parameters; let i = index" class="parameters">
      <span class="parameter"><smart-input [(model)]="token.parameters[i]" key="name"></smart-input></span>
      <span class="parameter"><smart-input [(model)]="token.parameters[i]" key="value"></smart-input></span>
      <span class="parameter-encrypted"><smart-input [(model)]="token.parameters[i]" key="encrypted"></smart-input></span>
      <span class="actions"><button (click)="removeParameter(i)" class="ibexfusion-icon-button" mat-icon-button><mat-icon>delete</mat-icon></button></span>
    </div>
    <button (click)="addParameter()" class="ibexfusion-raised-button" mat-button>Parameter hinzufügen</button>
  </mat-card>
</ng-container>

<!--
<mat-form-field>
  <input [(ngModel)]="profile.email" matInput placeholder="{{'userAdmin.profile.email' | translate}}" type="email"/>
</mat-form-field>
<div class="error-message" *ngIf="emailInvalid || emailAlreadyExists">
  {{'userAdmin.errors.' + (emailInvalid ? 'emailInvalid' : 'emailAlreadyExists') | translate}}
</div>

<smart-input [(model)]="profile" key="firstName" translationPrefix="userAdmin.profile"></smart-input>
<div class="error-message" *ngIf="firstNameInvalid">{{'userAdmin.errors.firstNameInvalid' | translate}}</div>
<smart-input [(model)]="profile" key="lastName" translationPrefix="userAdmin.profile"></smart-input>
<div class="error-message" *ngIf="lastNameInvalid">{{'userAdmin.errors.lastNameInvalid' | translate}}</div>
-->
<div class="buttons">
  <button (click)="abort()" class="ibexfusion-raised-button" mat-button>{{ 'general.cancel' | translate }}</button>
  <button (click)="save()" class="ibexfusion-raised-button" mat-button>{{ 'general.add' | translate }}</button>
</div>
